define('Winering.Collection', [
    'Backbone.CachedCollection',
    'Winering.Model',
    'Utils'
], function WineringCollection(
    CachedCollection,
    WineringModel,
    Utils
) {
    'use strict';

    return CachedCollection.extend({
        model: WineringModel,
        url: Utils.getAbsoluteUrl(getExtensionAssetsPath('services/Winering.Service.ss'))
    });
});
